"use strict";

exports.__esModule = true;
exports["default"] = ArrowRight;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowRight(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "-229.5 -44 120 120",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-137.516 23.744h-83.036c-4.373 0-7.933-3.54-7.933-7.911 0-4.36 3.561-7.92 7.933-7.92h83.036l-34.417-34.381a7.89 7.89 0 0 1 0-11.173 7.887 7.887 0 0 1 11.179 0l47.938 47.893c.683.72 1.282 1.575 1.663 2.57a7.46 7.46 0 0 1 .638 3.018c0 1.062-.223 2.071-.638 3.065-.381.946-.98 1.814-1.663 2.544l-48.201 48.148a7.779 7.779 0 0 1-5.589 2.366 7.718 7.718 0 0 1-5.59-2.366c-3.09-3.052-3.09-8.075 0-11.18l34.68-34.673z"
  }));
}